export const PROJECT_ERROR_INITIALIAZE = 'PROJECT_ERROR_INITIALIAZE';
export const PROJECT_ERROR_ON_UPDATE = 'PROJECT_ERROR_ON_UPDATE';
